var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.twMerge('mt-1 text-sm text-gray-500', _vm.twClass)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }